import { FSA } from 'flux-standard-action';
import { assign as _assign } from 'lodash';

import { 
  ConfigurationValidationPartState, 
  ConfigurationValidationByItem
} from 'franke-trough-dependencies';

import { 
  ConfigurationValidationTypes, 
  ValidateConfigurationPayload,
} from './validation.action';

import {
  validateConfigurationByPart, 
  navigationConfigurationKeys,
  disableConfigurationParts,
  validateConfigurationByItem, 
} from './validation.utils';

export interface ConfigurationValidationState {
  byPart: ConfigurationValidationPartState;
  byItem: ConfigurationValidationByItem;
  checkedAt: Date;
  disabled: ConfigurationValidationPartState;
  id?: string;
}

const initialPartState: ConfigurationValidationPartState =  {
  selectedTrough: false,
  washBasinDimension: false,
  apronBackSplash: false,
  builtInParts: false,
  surface: false,
  assemblyAccessories: false,
  drainAccessories: false,
};

export const validationInitialState: ConfigurationValidationState = {
  byPart: initialPartState,
  byItem: {
    selectedTrough: undefined,
    washBasinDimension: undefined,
    apronBackSplash: undefined,
    builtInParts: undefined,
    surface: undefined,
    assemblyAccessories: undefined,
    drainAccessories: undefined,
  },
  checkedAt: new Date(),
  disabled: initialPartState,
};

export const configurationValidationReducer = (
  state: ConfigurationValidationState = validationInitialState,
  action: FSA<ConfigurationValidationTypes, ValidateConfigurationPayload | undefined>
): ConfigurationValidationState => {
  switch (action.type) {
    case ConfigurationValidationTypes.validate:
      return !action.payload ? state : _assign({}, state, {
        checkedAt: action.payload.configuration.updated_at,
        byPart: validateConfigurationByPart(navigationConfigurationKeys, action.payload.configuration, action.payload.error),
        byItem: validateConfigurationByItem(navigationConfigurationKeys, action.payload.configuration, action.payload.error),
        disabled: disableConfigurationParts(validateConfigurationByPart(navigationConfigurationKeys, action.payload.configuration)),
      });
    case ConfigurationValidationTypes.clear:
      return validationInitialState;
    default:
      return state;
  }
};